import { defineWidgetSettings } from "@nexus/widget-sdk";
import { plainTextToRichText } from "./richText";

/** What an author sets on a text note: the text itself first. */
export const settings = defineWidgetSettings({
  id: "text-note",
  properties: {
    // A note has no title unless its author gives one.
    title: { default: "" },
    html: {
      type: "string",
      title: "Text",
      "x-ui": {
        category: "content",
        control: "richtext",
        order: 10,
        // Notes from before formatting stored plain text: the first edit replaces it.
        resets: ["text"],
      },
    },
    size: {
      type: "string",
      title: "Text size",
      default: "auto",
      oneOf: [
        { const: "auto", title: "Auto — fits the space" },
        { const: "sm", title: "Small" },
        { const: "md", title: "Medium" },
        { const: "lg", title: "Large" },
        { const: "xl", title: "Extra large" },
      ],
      "x-ui": { category: "content", order: 20 },
    },
    style: {
      type: "string",
      title: "Style",
      description:
        "Banner: the title as a label beside the text, on one line, with the bold words as key figures. Suits a note above dashboard tiles.",
      default: "standard",
      oneOf: [
        { const: "standard", title: "Standard" },
        { const: "banner", title: "Banner" },
      ],
      "x-ui": { category: "display", order: 5, summary: true },
    },
    showFrame: {
      type: "boolean",
      title: "Frame",
      description: "Show the border and background around the text",
      default: true,
      "x-ui": { category: "display", order: 10 },
    },
  },
  overlay: ({ config }) =>
    typeof config.html === "string" || typeof config.text !== "string"
      ? {}
      : { fallbacks: { html: plainTextToRichText(config.text) } },
});
